import React from 'react';

import * as ScoreType from 'constants/ScoreType';

export default class AdditionalScore extends React.Component {
    static propTypes = {
        score: React.PropTypes.object
    };

    static renderRegularScore(score) {
        const scoreId = score.get('id');

        const score1 = score.get('score1');
        const score2 = score.get('score2');

        if (score1 > score2) {
            return (
                <span key={scoreId} className="additional"><strong>{score1}</strong><span>{':' + score2}</span></span>
            );
        }
        if (score1 < score2) {
            return (
                <span key={scoreId} className="additional"><span>{score1 + ':'}</span><strong>{score2}</strong></span>
            );
        }

        return (<span key={scoreId} className="additional">{score1 + ':' + score2}</span>);
    }

    static renderTennisGameScore(score) {
        const scoreId = score.get('id');

        const team = score.get('team');
        let score1 = score.get('score1');
        let score2 = score.get('score2');

        score1 = score1 === 100 ? 'A' : score1;
        score2 = score2 === 100 ? 'A' : score2;

        let result = score1 + ':' + score2;

        if (team !== null) {

            if (team === 1) {
                result = '*' + result;
            } else if (team === 2) {
                result = result + '*';
            }
        }

        return (<span key={scoreId} className="additional">{result}</span>);
    }

    render() {
        const score = this.props.score;

        if (score === undefined || score.get('score1') === null || score.get('score2') === null) {
            return null;
        }

        const scoreType = score.get('type');

        if (scoreType === ScoreType.CurrentGame) {
            return AdditionalScore.renderTennisGameScore(score);
        }

        return AdditionalScore.renderRegularScore(score);
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/AdditionalScore.jsx